module.exports = __webpack_public_path__ + "img/DennisPoersel_140x140_rund.31937c75.jpg";